module.exports = __webpack_public_path__ + "images/spinner.c628ebacfd1ca00258d4.svg";